<template>
	<div class="flex items-center justify-between gap-2 min-w-0 w-full min-h-8">
		<span class="typo-body-s truncate text-body-tertiary shrink min-w-0">
			{{ displayName }}
		</span>
		<div v-if="items.length" class="flex items-center shrink-0">
			<template v-for="(item, index) in visibleItems" :key="index">
				<span
					class="relative shrink-0"
					:class="{'-ml-2': index > 0}"
					:style="{zIndex: index + 1}"
				>
					<span
						v-if="isTextItem(item)"
						class="flex size-8 items-center justify-center rounded-full border border-border-tertiary bg-background-secondary"
					>
						<NuxtIcon name="custom/handwrite" filled class="text-sm text-icon-primary" />
					</span>
					<NuxtImg
						v-else
						:src="itemImage(item)"
						:alt="item.Text || ''"
						width="32"
						height="32"
						class="size-8 rounded-full border border-border-tertiary object-contain bg-white"
						loading="lazy"
					/>
				</span>
			</template>
			<span
				v-if="overflowCount > 0"
				class="relative flex size-8 shrink-0 items-center justify-center rounded-full border border-border-tertiary bg-white -ml-2 typo-body-caption font-semibold text-body-secondary"
				:style="{zIndex: visibleItems.length + 1}"
			>
				+{{ overflowCount }}
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {ShoppingListPreviewItem} from '~/types/shoppingListPreview';
	import {appendShoppingListDateSuffix} from '~/utils/shoppingList';

	interface Props {
		name: string
		items: ShoppingListPreviewItem[]
		maxThumbnails?: number
		withDateSuffix?: boolean
	}

	const props = withDefaults(defineProps<Props>(), {
		maxThumbnails: 4,
		withDateSuffix: false,
	});

	const displayName = computed(() => (
		props.withDateSuffix ? appendShoppingListDateSuffix(props.name) : props.name
	));

	const visibleItems = computed(() => props.items.slice(0, props.maxThumbnails));
	const overflowCount = computed(() => Math.max(0, props.items.length - props.maxThumbnails));

	function isTextItem(item: ShoppingListPreviewItem): boolean {
		return !item.VANR || !!item.GeneralizedProduct;
	}

	function itemImage(item: ShoppingListPreviewItem): string {
		return item.productDetail?.imgDetail || '/images/product-placeholder.jpg';
	}
</script>
